import React from "react";
import { Accordion, AccordionTab } from "primereact/accordion";
import { getName } from "country-list";
import crossIcon from "../../assets/images/cross-icon.png";
import checkIcon from "../../assets/images/tick-icon.png";
import { PayslipStatusMap } from "~/utils/fileUtils";
const ChangesAccordian = ({ old_data, new_data }) => {
  const formatKey = (key) => {
    const formattedKey = key
      .replace(/_/g, " ")
      .replace(/\b\w/g, (char) => char.toUpperCase())
      .toLowerCase()
      .replace(/^\w/, (char) => char.toUpperCase());

    return formattedKey;
  };

  function isValidCountryCode(code) {
    return typeof code === "string" && getName(code) !== undefined;
  }
  const dueDateformatDate = (dateString) => {
    if (dateString) {
      const date = new Date(dateString);
      const day = date.getDate();
      const suffixes = ["th", "st", "nd", "rd"];
      const suffixIndex =
        day % 10 > 3 || Math.floor((day % 100) / 10) === 1 ? 0 : day % 10;
      const suffix = suffixes[suffixIndex];
      return `${date.toLocaleString("en-US", { month: "short" })} ${day}${suffix}, ${date.getFullYear()}`;
    }
    return "-";
  };

  const clean = (key, value) => {
    if (!value) return "";
    if (Array.isArray(value)) {
      return value.map((x) => <div key={x}>{clean(key, x)}</div>);
    }
    if (typeof value === "object") {
      return Object.keys(value)
        .map((k) => clean(k, value[k], k))
        .join(", ");
    }
    if (key === "start_date" || key === "end_date") {
      return new Date(value).toLocaleDateString();
    }
    if (
      [
        "due_date",
        "acquisition_date",
        "sale_closure_date",
        "incorporation_date",
        "date_of_birth",
        "expiration_date",
        "in_progress_at",
        "completed_at",
      ].includes(key)
    ) {
      return dueDateformatDate(value);
    }
    if (isValidCountryCode(value) && key.includes("country")) {
      return getName(value);
    }
    if (typeof value === "boolean") {
      return value.toString();
    }
    if (value === "approved" && key === "match_status") {
      return PayslipStatusMap[value] || "Approved";
    }
    if (value === "rejected" && key === "match_status") {
      return PayslipStatusMap[value] || "Rejected";
    }
    if (
      (value === "matched" ||
        value === "unmatched" ||
        value === "no_match" ||
        value === "extraction_failed") &&
      key === "match_status"
    ) {
      return "Awaiting Review";
    }
    if (value === "disabled") {
      return (
        <span className="history-enable-icon-container">
          Disabled{" "}
          <img className="history-enable-icon" src={crossIcon} alt="Disabled" />
        </span>
      );
    }
    if (value === "enabled") {
      return (
        <span className="history-enable-icon-container">
          Enabled <img src={checkIcon} alt="Enabled" />
        </span>
      );
    }

    return value;
  };

  return (
    <div className="changes-accordian">
      <Accordion>
        <AccordionTab header="Compare Changes">
          <div className="change-card new-changes">
            <h6 className="title">Changes</h6>
            {Object.entries(new_data).map(([key, value], i) => (
              <div key={key + value + i} className="changes-overflow">
                <span>{formatKey(key)}:</span>{" "}
                <span>{decodeURIComponent(clean(key, value))}</span>
              </div>
            ))}
          </div>

          <span className="divider" />
          <div className="change-card old-changes">
            <h6 className="title">Previous</h6>
            {Object.entries(old_data).map(([key, value], i) => (
              <div key={key + value + i} className="changes-overflow">
                <span>{formatKey(key)}:</span>{" "}
                <span>{decodeURIComponent(clean(key, value))}</span>
              </div>
            ))}
          </div>
        </AccordionTab>
      </Accordion>
    </div>
  );
};

export default ChangesAccordian;
